<template>
  <v-card>
    <v-card-title>
      Importy ({{ count }})

      <v-spacer/>

      <Create
          :icon="true"
          @init="init"
      />

      &nbsp;

      <v-btn
          :icon="true"
          :outlined="true"
          :loading="loading"
          :disabled="loading"
          color="default"
          @click="init"
      >
        <v-icon>
          mdi-refresh
        </v-icon>
      </v-btn>

      &nbsp;

      <ProcessItems
          :icon="true"
      />
    </v-card-title>

    <v-card-text>
      <v-row>
        <v-col
            cols="12"
        >
          <v-text-field
              v-model="params.Filters.query"
              :error-messages="errors.Filters && errors.Filters.query"
              :outlined="true"
              :dense="true"
              hide-details="auto"
              label="Vyhľadávanie"
              :clearable="true"
              @change="setFilter"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col
            cols="12"
        >
          <v-expansion-panels
              v-model="expansionPanelsFilter"
              :multiple="true"
          >
            <v-expansion-panel>
              <v-expansion-panel-header>
                <span>
                  <v-icon
                      color="info"
                  >
                    mdi-filter
                  </v-icon>

                  Filtre
                </span>
              </v-expansion-panel-header>

              <v-expansion-panel-content>
                <v-row>
                  <v-col
                      cols="12"
                      lg="3"
                  >
                    <v-select
                        v-model="params.Filters.status"
                        :error-messages="errors.Filters && errors.Filters.status"
                        :outlined="true"
                        :dense="true"
                        hide-details="auto"
                        label="Stav"
                        :items="$store.getters['register/getImportStatus']"
                        :clearable="true"
                        @change="setFilter"
                    />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>

      <v-row>
        <v-col
            cols="12"
        >
          <v-card>
            <v-card-text>
              <v-progress-linear
                  v-if="loading"
                  :indeterminate="true"
              />

              <v-simple-table>
                <template
                    v-slot:default
                >
                  <thead>
                    <tr>
                      <th>
                        <a
                            @click="setOrder($store.state.register.Import.Filter.order['im.createdAt'].value)"
                        >
                          <v-icon
                              v-if="params.order === $store.state.register.Import.Filter.order['im.createdAt'].value"
                          >
                            {{
                              params.by === $store.state.register.Import.Filter.by['ASC'].value
                                ? 'mdi-chevron-up'
                                : 'mdi-chevron-down'
                            }}
                          </v-icon>

                          Dátum založenia
                        </a>
                      </th>

                      <th>
                        Položiek - Vytvorených
                      </th>

                      <th>
                        Položiek - Upravených
                      </th>

                      <th>
                        <a
                            @click="setOrder($store.state.register.Import.Filter.order['im.updatedAt'].value)"
                        >
                          <v-icon
                              v-if="params.order === $store.state.register.Import.Filter.order['im.updatedAt'].value"
                          >
                            {{
                              params.by === $store.state.register.Import.Filter.by['ASC'].value
                                ? 'mdi-chevron-up'
                                : 'mdi-chevron-down'
                            }}
                          </v-icon>

                          Dátum dokončenia
                        </a>
                      </th>

                      <th>
                        Stav
                      </th>

                      <th>
                        Archív
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <template
                        v-if="imports.length > 0"
                    >
                      <tr
                          v-for="Import in imports"
                          :key="Import.id"
                      >
                        <td>
                          {{ dateFormat(new Date(Import.createdAt), 'DD.MM.YYYY HH:mm') }}
                        </td>

                        <td>
                          {{ Import.itemsCreate }}
                        </td>

                        <td>
                          {{ Import.itemsUpdate }}
                        </td>

                        <td>
                          {{
                            Import.updatedAt
                              ? dateFormat(new Date(Import.updatedAt), 'DD.MM.YYYY HH:mm')
                              : 'Nevyplnené'
                          }}
                        </td>

                        <td>
                          {{ $store.state.register.Import.status[Import.status].text }}
                        </td>

                        <td>
                          <a
                              v-if="Import.File"
                              :href="loadLinkByPath('files/generate/zip/' + Import.File.token)"
                              target="_blank"
                          >
                            <v-icon
                                color="primary"
                            >
                              mdi-download
                            </v-icon>
                          </a>

                          <template
                              v-else
                          >
                            <v-icon
                                color="error"
                            >
                              mdi-close
                            </v-icon>
                          </template>
                        </td>
                      </tr>
                    </template>

                    <template
                        v-else
                    >
                      <tr>
                        <td
                            colspan="6"
                            class="text-center"
                        >
                          Nenašli sa žiadne importy.
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row
          v-if="pages !== 0"
          align="center"
      >
        <v-col
            cols="4"
        >
          <a
              v-for="(limit, i) in $store.getters['register/getImportFilterLimit']"
              :key="i"
              @click="setLimit(limit.value)"
          >
            {{ limit.text }}
          </a>
        </v-col>

        <v-spacer/>

        <v-col
            cols="auto"
        >
          <v-btn
              :icon="true"
              :outlined="true"
              :loading="loading"
              :disabled="params.page === 1 || loading"
              color="primary"
              @click="previousPage"
          >
            <v-icon>
              mdi-chevron-left
            </v-icon>
          </v-btn>
        </v-col>

        <v-col
            cols="auto"
        >
          {{ params.page }} / {{ pages }}
        </v-col>

        <v-col
            cols="auto"
        >
          <v-btn
              :icon="true"
              :outlined="true"
              :loading="loading"
              :disabled="params.page === pages || loading"
              color="primary"
              @click="nextPage"
          >
            <v-icon>
              mdi-chevron-right
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  import Qs from 'qs'
  import QueryTypes from 'query-types'

  import { dateFormat } from '@vuejs-community/vue-filter-date-format'

  import Imports from '@/services/imports'

  import Create from '@/components/Imports/Create'
  import ProcessItems from '@/components/ProcessItems'

  export default {
    name: 'Imports',
    components: {
      Create,
      ProcessItems
    },
    data() {
      return {
        expansionPanelsFilter: [],
        loading: false,
        count: 0,
        pages: 1,
        imports: [],
        params: {
          Filters: {
            query: '',
            status: ''
          },
          order: this.$store.state.register.Import.Filter.order['im.createdAt'].value,
          by: this.$store.state.register.Import.Filter.by['DESC'].value,
          limit: this.$store.state.register.Import.Filter.limit[25].value,
          page: 1
        },
        errors: {}
      }
    },
    metaInfo() {
      return {
        title: 'Importy'
      }
    },
    beforeMount() {
      this.beforeInit()
    },
    mounted() {
      this.init()
    },
    methods: {
      beforeInit() {
        this.params = {
          ...this.params,
          ...Qs.parse(QueryTypes.parseObject(this.$route.query))
        }
      },
      init() {
        this.loadData()
      },
      setFilter() {
        this.params.page = 1

        this.init()
      },
      setOrder(order) {
        this.params.order = order

        switch (this.params.by) {
          case this.$store.state.register.Import.Filter.by['ASC'].value:
            this.params.by = this.$store.state.register.Import.Filter.by['DESC'].value

            break

          case this.$store.state.register.Import.Filter.by['DESC'].value:
            this.params.by = this.$store.state.register.Import.Filter.by['ASC'].value

            break
        }

        this.params.page = 1

        this.init()
      },
      setLimit(limit) {
        this.params.limit = limit

        this.params.page = 1

        this.init()
      },
      previousPage() {
        this.params.page -= 1

        window.scrollTo(0, 0)

        this.init()
      },
      nextPage() {
        this.params.page += 1

        window.scrollTo(0, 0)

        this.init()
      },
      setBreadcrumbs() {
        this.$store.dispatch('layout/setBreadcrumbs', {
          breadcrumbs: [
            {
              text: 'Importy',
              to: '/imports'
            }
          ]
        })
      },
      loadData() {
        this.setBreadcrumbs()

        this.loading = true

        this.$router.replace('?' + Qs.stringify(this.params))

        Imports
          .index({
            params: this.params
          })
          .then((response) => {
            this.count = response.data.data.count

            this.pages = response.data.data.pages

            this.imports = response.data.data.imports

            this.errors = {}
          })
          .catch((error) => {
            switch (error.response.status) {
              case 400:
                this.errors = error.response.data.errors

                break

              case 401:
              case 500:
                this.$store.dispatch('layout/openSnackbar', {
                  message: error.response.data.message
                })

                break
            }
          })
          .finally(() => {
            this.loading = false
          })
      },
      dateFormat(input, format) {
        return dateFormat(input, format)
      },
      loadLinkByPath(path) {
        return process.env.VUE_APP_AXIOS_URL + path
      }
    }
  }
</script>
